<p-tag [value]="labelKey() | translate" [severity]="severity()"></p-tag>
